import { render, staticRenderFns } from "./BtnSmallAccept.vue?vue&type=template&id=74b7142e"
import script from "./BtnSmallAccept.vue?vue&type=script&lang=js"
export * from "./BtnSmallAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports